import addTrend from './addTrend'
import capabilities from './capabilities'
import card from './card'
import contact from './contact'
import contextMenu from './context-menu'
import deprecatedTrends from './deprecated-trends'
import description from './description'
import deletion from './deletion'
import edit from './edit'
import filter from './filter'
import form from './form'
import header from './header'
import list from './list'
import marketOpportunities from './market-opportunities'
import innovationProjects from './innovation-projects'
import publicLink from './public-link'
import selection from './selection'
import stateSwitch from './state-switch'
import technologicalOpportunities from './technological-opportunities'
import threads from './threads'
import trends from './trends'

export default {
    addTrend,
    capabilities,
    card,
    contact,
    contextMenu,
    deletion,
    deprecatedTrends,
    description,
    edit,
    filter,
    form,
    header,
    list,
    marketOpportunities,
    innovationProjects,
    publicLink,
    selection,
    stateSwitch,
    technologicalOpportunities,
    threads,
    trends
}
